import React from 'react';
import styles from './loadingSpinner.module.scss';

const LoadingSpinner = (props) => (
  <div className={`${props.cxtClassName ? styles[props.cxtClassName] : ''} ${styles.ldsRoller}`}>
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>
);

export default LoadingSpinner;
